var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-bottom",attrs:{"id":"footer"}},[_vm._v("Copyright © "+_vm._s(_vm.year)+" Delta IT. All Rights Reserved.")])
}
var staticRenderFns = []

export { render, staticRenderFns }